"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Auth_1 = require("./Auth");
const MsGraphApi_1 = __importDefault(require("./MsGraphApi"));
const getGraphApiClient = async () => {
    const token = await Auth_1.aquireToken('graphApi');
    return MsGraphApi_1.default(token.accessToken);
};
exports.getProfileInfo = async () => {
    const graphClient = await getGraphApiClient();
    const profile = await graphClient.getCurrentUserInfo();
    const profileImageUrl = await graphClient.getCurrentUserPhotoDataUrl(96);
    return {
        fullName: profile.displayName,
        initals: profile.givenName[0] + ' ' + profile.surname[0],
        avatarUrl: profileImageUrl,
        position: profile.jobTitle
    };
};
